const Separator = () => {
    return <div className={'border-t border-gray-300 w-full sm:my-7 my-5'} />
}

export default Separator;
